module.exports = __webpack_public_path__ + "static/media/sevminbrandingThumb.dad3da96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/sevminbrandingThumb.jpg
// module id = 436
// module chunks = 0